<!-- superadmin-companies.component.html -->

<div class="sac">

  <!-- ── Header ──────────────────────────────────── -->
  <div class="sac__header">
    <div>
      <h1 class="sac__title">Companies</h1>
      <p class="sac__subtitle">All organisations registered on the FieldOps platform.</p>
    </div>
    <div class="sac__header-right">
      <div class="sac__search-wrap">
        <svg class="sac__search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8"/>
          <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <input
          class="sac__search"
          type="text"
          placeholder="Search companies…"
          [(ngModel)]="searchQuery"
          (input)="applyFilter()"/>
      </div>

      <!-- Status toggle -->
      <div class="sac__toggle-group">
        <button class="sac__toggle-btn"
                [class.sac__toggle-btn--active]="statusFilter === 'all'"
                (click)="statusFilter = 'all'; applyFilter()">All</button>
        <button class="sac__toggle-btn"
                [class.sac__toggle-btn--active]="statusFilter === 'active'"
                (click)="statusFilter = 'active'; applyFilter()">Active</button>
        <button class="sac__toggle-btn"
                [class.sac__toggle-btn--active]="statusFilter === 'suspended'"
                (click)="statusFilter = 'suspended'; applyFilter()">Suspended</button>
      </div>
    </div>
  </div>

  <!-- ── Summary chips ───────────────────────────── -->
  <div class="sac__chips" *ngIf="!loading">
    <div class="sac__chip">
      <span class="sac__chip-dot sac__chip-dot--all"></span>
      <span class="sac__chip-label">Total</span>
      <span class="sac__chip-val">{{ companies.length }}</span>
    </div>
    <div class="sac__chip">
      <span class="sac__chip-dot sac__chip-dot--active"></span>
      <span class="sac__chip-label">Active</span>
      <span class="sac__chip-val">{{ activeCount }}</span>
    </div>
    <div class="sac__chip">
      <span class="sac__chip-dot sac__chip-dot--suspended"></span>
      <span class="sac__chip-label">Suspended</span>
      <span class="sac__chip-val">{{ suspendedCount }}</span>
    </div>
  </div>

  <!-- ── Table Card ──────────────────────────────── -->
  <div class="sac__card">

    <!-- Loading -->
    <div class="sac__loading" *ngIf="loading">
      <div class="sac__spinner"></div>
      <span>Loading companies…</span>
    </div>

    <!-- Empty -->
    <div class="sac__empty" *ngIf="!loading && filtered.length === 0">
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <path d="M3 21V7L12 3L21 7V21" stroke="currentColor" stroke-width="1.4"
              stroke-linecap="round" stroke-linejoin="round"/>
        <rect x="9" y="14" width="6" height="7" rx="1" stroke="currentColor" stroke-width="1.4"/>
      </svg>
      <p>{{ searchQuery ? 'No companies match your search.' : 'No companies registered yet.' }}</p>
    </div>

    <!-- Table -->
    <div class="sac__table-wrap" *ngIf="!loading && filtered.length > 0">
      <table class="sac__table">
        <thead>
          <tr>
            <th class="sac__th">Company</th>
            <th class="sac__th sac__th--center">Workers</th>
            <th class="sac__th sac__th--center">Admins</th>
            <th class="sac__th sac__th--center">Jobs</th>
            <th class="sac__th sac__th--center">Logs</th>
            <th class="sac__th">Joined</th>
            <th class="sac__th sac__th--center">Status</th>
            <th class="sac__th sac__th--center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr class="sac__row" *ngFor="let c of pagedCompanies">

            <!-- Company -->
            <td class="sac__td">
              <div class="sac__company-cell">
                <div class="sac__avatar">
                  {{ c.name.charAt(0).toUpperCase() }}
                </div>
                <div class="sac__company-info">
                  <span class="sac__company-name">{{ c.name }}</span>
                  <span class="sac__company-id">ID: {{ c.id | slice:0:8 }}…</span>
                </div>
              </div>
            </td>

            <!-- Workers -->
            <td class="sac__td sac__td--center">
              <span class="sac__count-badge sac__count-badge--blue">{{ c.workerCount }}</span>
            </td>

            <!-- Admins -->
            <td class="sac__td sac__td--center">
              <span class="sac__count-badge sac__count-badge--purple">{{ c.adminCount }}</span>
            </td>

            <!-- Jobs -->
            <td class="sac__td sac__td--center">
              <span class="sac__count-badge sac__count-badge--green">{{ c.jobCount }}</span>
            </td>

            <!-- Logs -->
            <td class="sac__td sac__td--center">
              <span class="sac__count-badge sac__count-badge--teal">{{ c.logCount }}</span>
            </td>

            <!-- Joined -->
            <td class="sac__td sac__td--muted">
              {{ c.createdUtc | date:'MMM d, y' }}
            </td>

            <!-- Status -->
            <td class="sac__td sac__td--center">
              <span class="sac__status"
                    [class.sac__status--active]="c.isActive"
                    [class.sac__status--suspended]="!c.isActive">
                <span class="sac__status-dot"></span>
                {{ c.isActive ? 'Active' : 'Suspended' }}
              </span>
            </td>

            <!-- Actions -->
            <td class="sac__td sac__td--center">
              <div class="sac__actions">
                <a [routerLink]="['/superadmin/companies', c.id]"
                   class="sac__action-btn sac__action-btn--view"
                   title="View details">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                          stroke="currentColor" stroke-width="1.8"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
                  </svg>
                </a>

                <button *ngIf="c.isActive"
                        class="sac__action-btn sac__action-btn--suspend"
                        title="Suspend company"
                        (click)="openConfirm(c, 'suspend')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"
                          stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                  </svg>
                </button>

                <button *ngIf="!c.isActive"
                        class="sac__action-btn sac__action-btn--reactivate"
                        title="Reactivate company"
                        (click)="openConfirm(c, 'reactivate')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </td>

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="sac__pagination" *ngIf="totalPages > 1">
        <span class="sac__pagination-info">
          Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, filtered.length) }}
          of {{ filtered.length }}
        </span>
        <div class="sac__pagination-controls">
          <button class="sac__page-btn"
                  (click)="goToPage(currentPage - 1)"
                  [disabled]="currentPage === 1">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="sac__page-btn sac__page-btn--num"
                  *ngFor="let p of pageNumbers"
                  [class.sac__page-btn--active]="p === currentPage"
                  (click)="goToPage(p)">{{ p }}</button>
          <button class="sac__page-btn"
                  (click)="goToPage(currentPage + 1)"
                  [disabled]="currentPage === totalPages">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Confirm Modal ────────────────────────────── -->
  <div class="sac__modal-overlay" *ngIf="confirmAction" (click)="closeConfirm()">
    <div class="sac__modal" (click)="$event.stopPropagation()">

      <div class="sac__modal-icon"
           [class.sac__modal-icon--danger]="confirmAction === 'suspend'"
           [class.sac__modal-icon--success]="confirmAction === 'reactivate'">
        <svg *ngIf="confirmAction === 'suspend'" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <svg *ngIf="confirmAction === 'reactivate'" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <h3 class="sac__modal-title">
        {{ confirmAction === 'suspend' ? 'Suspend Company?' : 'Reactivate Company?' }}
      </h3>
      <p class="sac__modal-desc" *ngIf="confirmAction === 'suspend'">
        <strong>{{ confirmCompany?.name }}</strong> and all its users will be deactivated
        immediately. They will not be able to log in until reactivated.
      </p>
      <p class="sac__modal-desc" *ngIf="confirmAction === 'reactivate'">
        <strong>{{ confirmCompany?.name }}</strong> and all its users will be restored
        and able to log in again.
      </p>

      <div class="sac__modal-actions">
        <button class="sac__modal-cancel" (click)="closeConfirm()">Cancel</button>
        <button class="sac__modal-confirm"
                [class.sac__modal-confirm--danger]="confirmAction === 'suspend'"
                [class.sac__modal-confirm--success]="confirmAction === 'reactivate'"
                (click)="executeAction()"
                [disabled]="acting">
          <span class="sac__btn-spinner" *ngIf="acting"></span>
          {{ acting ? 'Processing…' : (confirmAction === 'suspend' ? 'Suspend' : 'Reactivate') }}
        </button>
      </div>

    </div>
  </div>

</div>